import type { Action } from 'redux';
import dash_api from '../../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { GetRedditAuthenticationUrlPayload } from '../Reddit.types';

const GetRedditAuthenticationUrl = new ReduxAsyncAction<
  'GET_REDDIT_AUTHENTICATION_URL',
  string,
  GetRedditAuthenticationUrlPayload
>('GET_REDDIT_AUTHENTICATION_URL');
GetRedditAuthenticationUrl.registerRequest((authToken: string) => {
  return dash_api.get(`/v1/reddit/get-auth-url?authToken=${authToken}`).then(({ data }) => {
    return data;
  });
});
export const GET_REDDIT_AUTHENTICATION_URL = GetRedditAuthenticationUrl.actionNamespaceConstants;
export const getRedditAuthenticationUrl = GetRedditAuthenticationUrl.request;

export type GetRedditAuthenticationUrlAction = Action<typeof GET_REDDIT_AUTHENTICATION_URL.response> & {
  data: GetRedditAuthenticationUrlPayload;
};
